import * as React from 'react';
import { StyleSheet } from 'react-native';
import Colors from '../../constants/Colors';
import { Modalize } from 'react-native-modalize';
import { View, Text } from '../../components/Themed';
import useThemeColor from '../../hooks/useThemeColor';
import Layout from '../../constants/Layout';

type Props = {
  show: boolean;
  text: string;
  onClosed: () => void;
};

export default function BottomModal(props: Props) {
  const { show, text, onClosed } = props;

  const createOpenHouseModal = React.useRef<Modalize>(null);



  React.useEffect(() => {
    if (show) {
      createOpenHouseModal?.current?.open();

       setTimeout(() => {
        createOpenHouseModal?.current?.close();
        onClosed();
        
      }, 2000);
    } 
  }, [show]);

  return (
    <Modalize
      ref={createOpenHouseModal}
      modalHeight={Layout.window.height * 0.1}
      withReactModal
      withOverlay={false}
      childrenStyle={[
        styles.modalStyle,
        {
          backgroundColor: useThemeColor(
            { light: Colors.base_colors_black, dark: Colors.nuetral_grey_600 },
            'background',
          ),
        },
      ]}
    >
      <View style={styles.container}>
        <Text size={16} lightColor={Colors.base_colors_white} darkColor={Colors.base_colors_white}>
          {text}
        </Text>
      </View>
    </Modalize>
  );
}

const styles = StyleSheet.create({
  modalStyle: {
    padding: 24,
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  container: {
    alignItems: 'center',
  },
});
